<div class="field">
  <label for="DepartmentSelectorDd" class="do-not-wrap-text" *ngIf="showLabel">{{labelKey}} ({{selectedID}})</label>
  <p-dropdown id="DepartmentSelectorDd"
              [options]="_departmentslistMC"
              optionLabel="CLIENTSNIKNAME"
              [(ngModel)]="_departmentMC"
              [placeholder]="placeholder"
              filterPlaceholder="Поиск отдела..."
              [filter]="true"
              filterBy="CLIENTSNIKNAME"
              [showClear]="true"
              [required]="true"
              [disabled]="disabled"
              [autoDisplayFirst]="false"
              (onChange)="onChangeDS($event)"></p-dropdown>
</div>
